<template>
  <div>
    <template v-for="(item, index) in items">
      <v-list-item 
        class="my-0"
        :class="classes['item']"
        :style="localStyle['item']"
        :link="link"
        :key="(item[identifierKey] || index) + componentKey"
        v-on:click="clickItem(index)"
        v-if="filtersMatch(item) && !item.children"
      >
        <v-list-item-icon v-if="item[iconKey]" class="pr-0 mr-4">
          <v-icon>{{item[iconKey]}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content
          :class="classes['content-item']"
          :style="localStyle['content-item']"
        >
          <v-list-item-title v-html="item[titleKey]"></v-list-item-title>
          <v-list-item-subtitle v-if="item[subtitleKey]" v-html="item[subtitleKey]"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-group
        v-else
        sub-group
        no-action
        :class="classes['group']"
        :style="localStyle['group']"
        :key="(item[identifierKey] || index) + '-collapsable-item'"
      >
        <template v-slot:activator>
          <v-list-item-content
            :class="classes['content-group']"
            :style="localStyle['content-group']"
          >
            <v-list-item-title v-html="item[titleKey]"></v-list-item-title>
            <v-list-item-subtitle v-if="item[subtitleKey]" v-html="item[subtitleKey]"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <SubGroupList
          :items="item['children']"
          :filters="filters"
          :identifierKey="identifierKey"
          :divided="divided"
          :level="level + 1"
          :title-key="titleKey"
          :subtitle-key="subtitleKey"
          :styles="localStyle"
          :classes="classes"
          :title="item[titleKey]"
          :bus="bus"
          v-on:item-click="clickSubitem"
        ></SubGroupList>
      </v-list-group>
      <v-divider v-if="(index != items.length - 1) && divided && filtersMatch(item)" :key="index + '-divider'"></v-divider>
    </template>
  </div>
</template>

<script>
import emittable from '../../mixins/emittable.js'

import {
  VListItem,
  VListItemContent,
  VListItemTitle,
  VListItemSubtitle,
  VListGroup,
  VDivider
} from 'vuetify/lib'

export default {
  name: "SubGroupList",
  mixins: [emittable],
  components: {
    VListItem,
    VListItemContent,
    VListItemTitle,
    VListItemSubtitle,
    VListGroup,
    VDivider
  },
  data: function() {
    let ls = { ...this.styles }
    if(!ls['content-item']) {
      ls['content-item'] = {}
    }
    ls['content-item']['margin-left'] = (this.level * 10) + "px"

    if(!ls['content-group']) {
      ls['content-group'] = {}
    }
    ls['content-group']['margin-left'] = ((this.level * 10) - 10) + "px"
    
    return {
      localStyle: ls,
      componentKey: 0,
      titleFilter: undefined
    }
  },
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
    filters: {
      type: Array,
      default: function() {
        return []
      }
    },
    identifierKey: {
      type: String,
      default: 'id'
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 1
    },
    divided: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: undefined
    },
    link: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    titleKey: {
      type: String,
      default: 'title'
    },
    subtitleKey: {
      type: String,
      default: 'subtitle'
    },
    iconKey: {
      type: String,
      default: 'icon'
    },
    styles: {
      type: Object,
      default: function () {
        return {
          item: {},
          group: {},
          "content-item": {},
          "content-group": {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          item: {},
          group: {},
          "content-item": {},
          "content-group": {},
        };
      },
    },
  },
  methods: {
    clickItem(index) {
      this.emit('item-click', this.items[index], this.title)
    },
    clickSubitem(item, section) {
      this.emit('item-click', item, section)
    },
    filtersMatch(item) {
      return this.titleFilter == undefined || this.titleFilter == null || this.titleFilter == '' || item[this.titleKey].toLowerCase().includes(this.titleFilter.toLowerCase())
    }
  },
  watch: {
    items: function() {
      this.componentKey += 1
      // this.$forceUpdate();
    },
    filters: function(newVal) {
      this.componentKey += 1
      for(let i = 0; i < this.filters.length; i++) {
        if(this.filters[i]['key'] == this.titleKey) {
          this.titleFilter = this.filters[i]['value']
        }
      }
    },
  }
}
</script>

<style scoped>
.scrollable {
  height: 100%;
  overflow-y: scroll;
}
</style>